import { produce } from 'immer'
import { str } from './utils'
import { registrationActions } from '../actions/registration'
import {
  SET_SCHEDULE_OWNER,
  SET_TEAM_TO_CANCEL,
  TOGGLE_REGISTRATION_TAB,
  CLEAN_UP_PAYMENT_DATA,
  UPDATE_REGISTRATION_SETTINGS,
} from '../actions/registration'
import authActions from '../actions/auth'

const initialState = {
  enableRegistrationCog: false,
  enableRegistrationSetup: false,
  isLoading: false,
  error: null,
  divisions: [],
  registrationSettings: null,
  registration: null,
  availableTaxes: [],
  analytics: null,
  hasDepositPaymentAvailable: [],
  hasInstallmentsPaymentAvailable: [],
  scheduleOwner: null,
  teamToCancel: null,
}

export default (state = initialState, { type, payload }) =>
  produce(state, (draft) => {
    switch (type) {
      // loadDivisions
      case str(registrationActions.loadDivisions.request):
        draft.isLoading = true
        return
      case str(registrationActions.loadDivisions.success): {
        const { response, analytics } = payload
        draft.divisions = response.divisions
        draft.registration = response.registration
        draft.analytics = analytics
        draft.availableTaxes = response.available_taxes
        draft.enableRegistrationCog = response.registration ? true : null
        draft.enableRegistrationSetup = true
        draft.isLoading = false
        return
      }
      case str(registrationActions.loadDivisions.failure):
        draft.enableRegistrationSetup = false
        draft.divisions = null
        draft.availableTaxes = []
        draft.registration = null
        draft.enableRegistrationCog = null
        draft.isLoading = false
        return

      // createRegistration
      case str(registrationActions.createRegistration.request):
        draft.isLoading = true
        return
      case str(registrationActions.createRegistration.success):
        draft.isLoading = false
        draft.enableRegistrationCog = true
        return
      case str(registrationActions.createRegistration.failure):
        draft.isLoading = false
        return

      // getSettings
      case str(registrationActions.getSettings.request):
        draft.isLoading = true
        return
      case str(registrationActions.getSettings.success):
        draft.registrationSettings = payload.data
        draft.isLoading = false
        return
      case str(registrationActions.getSettings.failure):
        draft.isLoading = false
        return

      // updateRegistration
      case str(registrationActions.updateRegistration.request):
        draft.isLoading = true
        return
      case str(registrationActions.updateRegistration.success):
        draft.registrationSettings = payload.data
        draft.isLoading = false
        return
      case str(registrationActions.updateRegistration.failure):
        draft.isLoading = false
        return

      // updateDivision
      case str(registrationActions.updateDivision.success):
        draft.isLoading = false
        return
      case str(registrationActions.updateDivision.failure):
        draft.isLoading = false
        return

      // updateTeamRegStatus
      case str(registrationActions.updateTeamRegStatus.request):
        draft.isLoading = true
        return
      case str(registrationActions.updateTeamRegStatus.success):
        draft.isLoading = false
        return
      case str(registrationActions.updateTeamRegStatus.failure):
        draft.isLoading = false
        return

      // checkPayments
      case str(registrationActions.checkPayments.success):
        draft.hasDepositPaymentAvailable = (payload.deposits || []).filter(
          (d) => d?.deposit_amount > 0
        )
        draft.hasInstallmentsPaymentAvailable = payload.installments || []
        return

      // Simple actions
      case SET_SCHEDULE_OWNER:
        draft.scheduleOwner = payload
        return
      case SET_TEAM_TO_CANCEL:
        draft.teamToCancel = payload
        return
      case TOGGLE_REGISTRATION_TAB:
        draft.enableRegistrationCog = !draft.enableRegistrationCog
        return
      case CLEAN_UP_PAYMENT_DATA:
        draft.hasDepositPaymentAvailable = []
        draft.hasInstallmentsPaymentAvailable = []
        return
      case UPDATE_REGISTRATION_SETTINGS:
        draft.registrationSettings = {
          ...draft.registrationSettings,
          ...payload,
        }
        return

      case str(authActions.logout.success):
        return initialState
    }
  })
